import React from 'react';
import { Header } from '../components/Header';

export default class Agreement extends React.Component {
    render() {
        return (
            <>
                <Header simple={true} />
                <p className="o-form-wrapper__text_legal">
                    Пользовательское Соглашение
                    <br />
                    Настоящее Пользовательское Соглашение (Далее Соглашение) регулирует отношения между владельцем learnew.ru (далее Рабочая тетрадь по иностранному языку или Администрация) с одной стороны и пользователем сайта с другой.
                    <br />Сайт Рабочая тетрадь по иностранному языку не является средством массовой информации.
                    <br />
                    Используя сайт, Вы соглашаетесь с условиями данного соглашения.<br />
                    Если Вы не согласны с условиями данного соглашения, не используйте сайт Рабочая тетрадь по иностранному языку!
                    <br />
                    Предмет соглашения
                    <br />
                    <br />
                    - Текстовой информации<br />
                    - Ссылок на материалы, размещенные на других сайтах
                    <br />
                    Права и обязанности сторон
                    <br />
                    <br />
                    Пользователь имеет право:<br />
                    - осуществлять поиск информации на сайте<br />
                    - получать информацию на сайте<br />
                    - создавать информацию для сайта<br />
                    - распространять информацию на сайте<br />
                    - копировать информацию на другие сайты с указанием источника<br />
                    - копировать информацию на другие сайты с разрешения правообладателя<br />
                    - использовать информацию сайта в личных некоммерческих целях<br />
                    <br />
                    Администрация имеет право:
                    <br />
                    <br />
                    - по своему усмотрению и необходимости создавать, изменять, отменять правила<br />
                    - ограничивать доступ к любой информации на сайте<br />
                    - создавать, изменять, удалять информацию<br />
                    - удалять учетные записи<br />
                    <br />
                    Пользователь обязуется:<br />
                    <br />
                    <br />
                    - обеспечить достоверность предоставляемой информации<br />
                    - обеспечивать сохранность личных данных от доступа третьих лиц<br />
                    - не распространять информацию, которая направлена на пропаганду войны, разжигание национальной, расовой или религиозной ненависти и вражды, а также иной информации, за распространение которой предусмотрена уголовная или административная ответственность<br />
                    - не нарушать работоспособность сайта<br />
                    - не передавать в пользование свою учетную запись и/или логин и пароль своей учетной записи третьим лицам<br />
                    - не регистрировать учетную запись от имени или вместо другого лица за исключением случаев, предусмотренных законодательством РФ<br />
                    - не размещать материалы рекламного, эротического, порнографического или оскорбительного характера, а также иную информацию, размещение которой запрещено или противоречит нормам действующего законодательства РФ<br />
                    - не использовать скрипты (программы) для автоматизированного сбора информации и/или взаимодействия с Сайтом и его Сервисами<br />
                    <br />
                    Администрация обязуется:
                    <br />
                    <br />
                    - поддерживать работоспособность сайта за исключением случаев, когда это невозможно по независящим от Администрации причинам.<br />
                    - осуществлять разностороннюю защиту учетной записи Пользователя<br />
                    <br />
                    Ответственность сторон
                    <br />
                    <br />
                    - пользователь лично несет полную ответственность за распространяемую им информацию<br />
                    - администрация не несет никакой ответственности за достоверность информации, скопированной из других источников<br />
                    - администрация не несёт ответственность за несовпадение ожидаемых Пользователем и реально полученных услуг<br />
                    - администрация не несет никакой ответственности за услуги, предоставляемые третьими лицами<br />
                    - в случае возникновения форс-мажорной ситуации (боевые действия, чрезвычайное положение, стихийное бедствие и т. д.) Администрация не гарантирует сохранность информации, размещённой Пользователем, а также бесперебойную работу информационного ресурса<br />
                    <br />
                    Условия действия Соглашения
                    <br />
                    <br />
                    Данное Соглашение вступает в силу при любом использовании данного сайта.<br />
                    Соглашение перестает действовать при появлении его новой версии.<br />
                    Администрация оставляет за собой право в одностороннем порядке изменять данное соглашение по своему усмотрению.<br />
                    Администрация не оповещает пользователей об изменении в Соглашении.<br />

                    Соглашение разработано на базе юридических документов сервиса <a href='https://praville.ru/generator/a_gen.php#'>Правилль</a>
                    <br />
                    <br />
                    <br />
                    <br />
                </p>
            </>
        )

    }
}